import $bus from './bus'

const isProd = process.env.NODE_ENV === 'production'

const container = '#child--app-container'

// 已接入的子应用列表
export const childApps = [{
  label: '用户中心', // 会被后端配置覆盖
  name: 'identity_admin', // 子应用名称【与权限配置保持一致】
  entry: isProd ? '/child-identity_admin/' : '//localhost:9001/', // 子应用入口【不能同activeRule字段】
  container, // 挂载容器
  activeRule: '/identity_admin', // 激活的路由规则【给qiankun用的，不能同entry字段；与子应用router.base保持一致】
  props: { $bus, permissionTree: [], registerApps: [] }, // 子应用通信
  showTopBar: true
}, {
  label: '新商城',
  name: 'admin',
  entry: isProd ? '/child-admin/' : '//localhost:9002/',
  container,
  activeRule: '/admin',
  props: { $bus, permissionTree: [], registerApps: [] }, // 子应用通信
  showTopBar: true
}, {
  label: '品牌库',
  name: 'brand_admin',
  entry: isProd ? '/child-brand_admin/' : '//localhost:8009/',
  container,
  activeRule: '/brand_admin',
  props: { $bus, permissionTree: [], registerApps: [] }, // 子应用通信
  showTopBar: false
}]
